export default __webpack_public_path__ + "static/media/fire-protection.a3196010.jpg";